import React from 'react';
import {
  Dashboard as DashboardIcon,
  FilterAlt as FunnelIcon,
  Schedule as ScheduleIcon,
  Brush as BrushIcon,
  Forum as ForumIcon,
} from '@mui/icons-material';
import TabHub from '../../components/layout/TabHub';
import SocialDashboardPage from '../social/SocialDashboardPage';
import FunnelPage from '../social/FunnelPage';
import ContentCalendarPage from '../social/ContentCalendarPage';
import ArtesPage from '../social/ArtesPage';
import SocialInboxPage from '../social/SocialInboxPage';

// Hub de Redes Sociales: command center de métricas + embudo (Fase 1)
// + publicación/agenda y cola de artes (Fase 2) + bandeja de comentarios/DMs (Fase 3).
const RedesSocialesHub: React.FC = () => (
  <TabHub
    tabs={[
      { key: 'dashboard', label: 'Dashboard', icon: <DashboardIcon />, element: <SocialDashboardPage /> },
      { key: 'funnel', label: 'Embudo', icon: <FunnelIcon />, element: <FunnelPage /> },
      { key: 'contenido', label: 'Contenido / Agenda', icon: <ScheduleIcon />, element: <ContentCalendarPage /> },
      { key: 'artes', label: 'Artes', icon: <BrushIcon />, element: <ArtesPage /> },
      { key: 'bandeja', label: 'Bandeja', icon: <ForumIcon />, element: <SocialInboxPage /> },
    ]}
  />
);

export default RedesSocialesHub;
